export default __webpack_public_path__ + "content/media/sate84.c419b177.pdf";